// TeamInvoiceDrawer's read and writes (finance-real, the user 2026-10-22): the team invoice with the person's open claims,
// the jobs to claim another on and the clients a new job can go on; a draft's claims taken off, added, or claimed anew; its
// claim's amount changed in place (the job drawer's claim write); its status picked (Draft, Received), and the payout that
// makes it Paid.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useUpdateClaim } from "../../hooks/useJobClaims";
import {
  useAddTeamInvoiceClaims, useClaimOnTeamInvoice, usePayTeamInvoice, useRemoveTeamInvoiceClaim, useSetTeamInvoiceStatus, useTeamInvoice,
} from "../../hooks/useTeamInvoices";
import type { JobClaim, JobClaimInput, TeamInvoice, TeamInvoiceClaimInput, TeamInvoiceDetail, TeamInvoicePayoutInput, TeamInvoiceStatusInput } from "../../types";

export interface TeamInvoiceDrawerModel {
  detail: UseQueryResult<TeamInvoiceDetail>;
  remove: UseMutationResult<TeamInvoice, Error, { invoiceId: string; claimId: string }>;
  addOpen: UseMutationResult<TeamInvoice, Error, { invoiceId: string; claimIds: string[] }>;
  claim: UseMutationResult<TeamInvoice, Error, { invoiceId: string; input: TeamInvoiceClaimInput }>;
  updateClaim: UseMutationResult<JobClaim, Error, { claimId: string; input: JobClaimInput }>;
  setStatus: UseMutationResult<TeamInvoice, Error, { invoiceId: string; input: TeamInvoiceStatusInput }>;
  pay: UseMutationResult<TeamInvoice, Error, { invoiceId: string; input: TeamInvoicePayoutInput }>;
}

export function useTeamInvoiceDrawer(invoiceId: string): TeamInvoiceDrawerModel {
  return {
    detail: useTeamInvoice(invoiceId),
    remove: useRemoveTeamInvoiceClaim(),
    addOpen: useAddTeamInvoiceClaims(),
    claim: useClaimOnTeamInvoice(),
    updateClaim: useUpdateClaim(),
    setStatus: useSetTeamInvoiceStatus(),
    pay: usePayTeamInvoice(),
  };
}
